import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';

const NotFound = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto pt-16 px-4 text-center">
        <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">
          {t('notFound.title', 'Page Not Found')}
        </h2>
        <p className="text-gray-600 mb-8">
          {t('notFound.message', "We couldn't find the page you're looking for.")}
        </p>
        <Link 
          to="/"
          className="inline-block bg-blue-600 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-700 transition-colors"
        >
          {t('notFound.backHome', 'Back to Home')}
        </Link>
      </div>
    </div>
  );
};

export default NotFound; 